import { useEffect } from 'react';
import LoadingIndicatorFull from '../../../components/LoadingIndicatorFull';
import { getObjectFromStorage, updateObjectInStorage } from '../../../services/LocalStorage';
import { replaceUrl } from '../../../services/Router';
import { JUST_LAUNCHED_LOCAL_STORAGE_KEY } from './justLaunchedHasUpdateService';

/**
 * This component is only tracking a click and redirecting.
 */
export default function JustLaunchedHandler() {
    useEffect(() => {
        const state = getObjectFromStorage(JUST_LAUNCHED_LOCAL_STORAGE_KEY, { lastVisit: 0 });
        updateObjectInStorage(JUST_LAUNCHED_LOCAL_STORAGE_KEY, { ...state, lastVisit: Date.now() });
        replaceUrl('https://www.small-improvements.com/release-notes#notes-section');
    }, []);

    return <LoadingIndicatorFull />;
}
